<template type="text/x-template" id="tree-item-template">
  <li style="list-style-type: none; padding: 10">
    <div>
      <div class="row" style="justify-content: space-between">
        <div class="col-sm-9 label" @click="toggle">
          <img v-if="isFolder" :src="require(isOpen
            ? '../assets/images/arrowUpIcon.svg'
            : '../assets/images/arrowDownIcon.svg')
            " width="12" />
          &nbsp; - {{ item.name }}
        </div>
        <div class="col-sm-3 text-right access pr-0" style="display: inline-flex; justify-content:right">
          <div v-if="item.level != 'AREA'" @click="handleClick(item, 'ADD')">
            <img src="../assets/images/add.svg" width="16" />
          </div>
          <div v-if="item.level != 'ACTIVEFEATURE'" @click="handleClick(item, 'EDIT')">
            <img src="../assets/images/edit.svg" width="16" />
          </div>
        </div>
      </div>
    </div>
    <ul v-show="isOpen" v-if="isFolder">
      <!-- <tree-item
        v-for="(child, index) in item.children"
        :key="index"
        :item="child"
        :selectedFacility="selectedFacility"
        :selectedSamlGroup="selectedSamlGroup"
        :isEditable="isEditable"
      >
      </tree-item> -->
      <div v-for="(child, index) in item.children" :key="index" :item="child">
        <div class="row" style="justify-content: space-between">
          <div class="col-sm-9 label" @click="toggle1(child)" :class="{ activeClass: activeId === child.uniqueId }">
            <img v-if="child.children && child.children.length" :src="require(child.isOpen
              ? '../assets/images/arrowUpIcon.svg'
              : '../assets/images/arrowDownIcon.svg')
              " width="12" />
            &nbsp; - {{ child.name }}
          </div>
          <div class="col-sm-3 text-right access pr-0" style="display: inline-flex; justify-content:right; gap:10px">
            <div v-if="child.level != 'ACTIVEFEATURE'" @click="handleClick(child, 'EDIT')">
              <img src="../assets/images/edit.svg" width="16" />
            </div>
            <div v-if="child.level != 'AREA'" @click="handleClick(child, 'ADD')">
              <img src="../assets/images/add.svg" width="16" />
            </div>

          </div>
        </div>
        <ul v-show="child.isOpen" v-if="child.children && child.children.length">
          <div v-for="(child1, index) in child.children" :key="index" :item="child1">
            <div class="row" style="justify-content: space-between">
              <div class="col-sm-9 label" :class="{ activeClass: activeId === child1.uniqueId }">
                <!-- <img
                  v-if="isFolder"
                  :src="
                    require(isOpen
                      ? '../assets/images/arrowUpIcon.svg'
                      : '../assets/images/arrowDownIcon.svg')
                  "
                  width="12"
                  @click="toggle"
                /> -->
                &nbsp; - {{ child1.name }}
              </div>
              <div class="col-sm-3 text-right access pr-0" style="display: inline-flex; justify-content:end">
                <div v-if="child1.level != 'AREA'" @click="handleClick(child1, 'ADD')">
                  <img src="../assets/images/add.svg" width="16" />
                </div>
                <div v-if="child1.level != 'ACTIVEFEATURE'" @click="handleClick(child1, 'EDIT')">
                  <img src="../assets/images/edit.svg" width="16" />
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </ul>
  </li>
</template>

<script>
export default {
  name: "TreeItem",
  props: {
    item: Object,
    selectedFacility: {},
    selectedSamlGroup: {},
    isEditable: false,
  },
  data: function () {
    // console.log('tree - view', this.selectedSamlGroup);
    return {
      isOpen: false,
      globalAccess: true,
      node: {},
      activeId: "",
    };
  },
  mounted() {
    this.refreshTree();
  },
  computed: {
    isFolder: function () {
      return this.item.children && this.item.children.length;
    },
  },
  methods: {
    toggle: function () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
    },
    toggle1(child) {

      child.isOpen = !child.isOpen;

    },
    handleClick: function (data, val) {
      // alert(data.level);
      data.actionCommand = val;
      this.activeId = data.uniqueId;
      this.$emit("handleClickInParent", data);
    },
    onChecked(node, type, accessType) {
      this.updateChildNodeAccess(node, type, accessType);

      this.refreshTree();
    },
    refreshTree() {
      if (this.selectedFacility) {
        this.selectedFacility.roomAccessCount = 0;
        this.selectedFacility.roomAlertCount = 0;
        if (
          this.selectedFacility.children &&
          this.selectedFacility.children.length > 0
        ) {
          this.selectedFacility.children.forEach((activeFeature) => {
            if (activeFeature.children && activeFeature.children.length > 0) {
              let activeFeatureRoomCount = 0;
              let activeReatureRoomAccessCount = 0;
              let activeReatureRoomAlertCount = 0;
              activeFeature.children.forEach((unit) => {
                if (unit && unit.children && unit.children.length > 0) {
                  unit.children.forEach((area) => {
                    activeFeatureRoomCount++;
                    if (area && area.access) {
                      this.selectedFacility.roomAccessCount++;
                      activeReatureRoomAccessCount++;
                    }
                    if (area && area.alert) {
                      this.selectedFacility.roomAlertCount++;
                      activeReatureRoomAlertCount++;
                    }
                  });
                  if (activeFeatureRoomCount === activeReatureRoomAccessCount)
                    unit.access = true;
                  if (activeFeatureRoomCount === activeReatureRoomAlertCount)
                    unit.alert = true;
                }
              });
              // console.log('refresh', activeFeature, activeFeatureRoomCount, activeReatureRoomAccessCount, activeReatureRoomAlertCount)
              if (activeFeatureRoomCount === activeReatureRoomAccessCount)
                activeFeature.access = true;
              if (activeFeatureRoomCount === activeReatureRoomAlertCount)
                activeFeature.alert = true;
            }
          });
        }
      }
    },
    updateChildNodeAccess(node, type, accessType) {
      if (node.children && node.children.length > 0) {
        node.children.forEach((childNode) => {
          this.updateChildNodeAccess(childNode, type, accessType);
        });
      }
      node["access"] = type;
      this.selectedSamlGroup.locations = this.mergeArrayAttributes(
        this.selectedSamlGroup.locations,
        node.locationId,
        type
      );
      this.selectedSamlGroup.units = this.mergeArrayAttributes(
        this.selectedSamlGroup.units,
        node.unitId,
        type
      );
      this.selectedSamlGroup.areas = this.mergeArrayAttributes(
        this.selectedSamlGroup.areas,
        node.areaId,
        type,
        node.unitId
      );
      if (accessType === "alert") {
        node["alert"] = type;
        if (node.level === "AREA")
          this.selectedSamlGroup.alerts = this.mergeAlertAttributes(
            this.selectedSamlGroup.alerts,
            node.locationId,
            node.unitId,
            node.areaId,
            type
          );
      }
    },
    mergeAlertAttributes(alert, locationId, unitId, areaId, addOrRemove) {
      const aYearFromNow = new Date();
      aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 2);
      if (alert && alert.shift) {
        if (addOrRemove) {
          var alertShift = alert.shift.find(
            (s) =>
              s.location === locationId &&
              s.unit === unitId &&
              s.area === areaId
          );
          if (!alertShift) {
            alert.shift.push({
              location: locationId,
              unit: unitId,
              area: areaId,
              start: new Date(),
              end: aYearFromNow,
            });
          }
        } else {
          var alertShiftIndex = alert.shift.findIndex(
            (s) =>
              s.location === locationId &&
              s.unit === unitId &&
              s.area === areaId
          );
          if (alertShiftIndex !== -1) {
            alert.shift.splice(alertShiftIndex, 1);
          }
        }
      } else {
        alert = {
          shift: [],
        };
        alert.shift.push({
          location: locationId,
          unit: unitId,
          area: areaId,
          start: new Date(),
          end: aYearFromNow,
        });
      }
      return alert;
    },
    mergeArrayAttributes(list, value, addOrRemove) {
      if (!list || !Array.isArray(list)) list = [];
      if (!value || value === null) return list;
      if (addOrRemove) {
        if (list.indexOf(value) === -1) list.push(value);

        if (list.length === this.selectedFacility.roomCount) {
          list.forEach((e) => {
            if (this.selectedSamlGroup.areas.indexOf(e)) {
              this.selectedSamlGroup.areas.splice(e);
            }
          });
          list = [];
        }
      } else {
        var i = 0;
        while (i < list.length) {
          if (list[i] === value) {
            list.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
      return list;
    },
  },
};
</script>

<style>
.CheckbOXcontainer .checkmark:after {
  left: 5px;
  top: 2px;
  width: 3px;
  height: 7px;
  border: solid #ebebeb;
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);
}

.checkmark {
  border: 1px solid #ebebeb;
  border-radius: 3px;
}

.tree-group-expansion .tree-group-item>span {
  width: 140px !important;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}

.checkBox label {
  margin: 0;
  position: relative;
  top: -4px;
}

.access-level.checked {
  border-color: #66be6d;
}

label {
  color: #66be6d;
}

.access-level.unchecked label {
  color: "black";
}

.alert-level.checked {
  border-color: #f27778;
}

label {
  color: #3288D2;
}

.access-level.unchecked label {
  color: "black";
}

ul {
  padding-left: 1.5em;
  line-height: 1.5em;
  list-style-type: dot;
}

.col-sm-9.label {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
  max-width: 200px;
  line-height: 34px;
}

.activeClass {
  background: #eaf9ff;
  border-radius:5px;
  color:#1dd8f6;
}
</style>
